export default function useRetailPortalApi() {
  async function partner(jwt: string) {
    return await useFetch<Partner>('/sales-api/v1/partners', {
      headers: { jwt },
    })
  }

  return {
    partner,
  }
}
